import { useTranslation } from "react-i18next"

import { baseColumnDef } from "@/nzds/data-grid"
import { getDisplayValue } from "@/utils/value"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UseSiteNameColumnOptions {
  field?: string
  filterable?: boolean
}

export const useSiteNameColumn = <TRow extends GridValidRowModel>(
  options: UseSiteNameColumnOptions = {}
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const field = options.field ?? "site_name"
  const filterable = options.filterable ?? false

  return {
    ...baseColumnDef,
    field,
    filterable,
    flex: 1,
    headerName: t("fields.siteName.title"),
    minWidth: 120,
    sortable: true,
    valueFormatter: (value: string | null | undefined) =>
      getDisplayValue(value),
  }
}
